import {
  TOUR_MODEL_STATUS,
} from 'actions/tour/tour.actions';

const initialState = {
  modelStatus: false,
};

const tourReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOUR_MODEL_STATUS:
      return {
        ...state,
        modelStatus: action.data.modelStatus,
      };
    default:
      return state;
  }
};

export default tourReducer;
